var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1723 6C16.8341 6 15.3688 6.7293 13.8233 8.16783C13.094 8.8436 12.4516 9.57959 11.9833 10.1617C11.9833 10.1617 12.7326 11.0248 13.5556 11.9548C14.0039 11.3928 14.6395 10.6301 15.3822 9.9409C16.7538 8.65626 17.6504 8.39532 18.1656 8.39532C20.0926 8.39532 21.6582 10.0145 21.6582 12.0151C21.6582 13.9955 20.0926 15.6147 18.1656 15.6348C18.0719 15.6348 17.9649 15.6214 17.8311 15.5946C18.3931 15.8556 19.002 16.0429 19.5707 16.0429C23.1034 16.0429 23.7993 13.6008 23.8394 13.4268C23.9398 12.9785 24 12.5102 24 12.0284C23.9933 8.70309 21.3839 6 18.1723 6Z",
    fill: "url(#paint0_linear_4390_1065)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82771 18.03C7.16587 18.03 8.63117 17.3007 10.1767 15.8622C10.906 15.1864 11.5484 14.4504 12.0167 13.8683C12.0167 13.8683 11.2674 13.0052 10.4444 12.0752C9.99609 12.6372 9.36047 13.4 8.61778 14.0891C7.24616 15.3604 6.3429 15.6347 5.8344 15.6347C3.90744 15.6347 2.34179 14.0155 2.34179 12.015C2.34179 10.0345 3.90744 8.41529 5.8344 8.39521C5.92807 8.39521 6.03512 8.4086 6.16894 8.43536C5.60691 8.17442 4.99805 7.98707 4.42933 7.98707C0.89657 7.98038 0.200725 10.4225 0.16058 10.6032C0.0602174 11.0515 0 11.5198 0 12.0016C0 15.3269 2.60942 18.03 5.82771 18.03Z",
    fill: "url(#paint1_linear_4390_1065)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51743 9.99442C8.12937 9.61974 6.24255 8.08754 4.43603 8.03401C1.21105 7.95372 0.267645 10.2955 0.180664 10.5966C0.802911 7.97379 3.10456 6.01338 5.83441 6C8.06246 6 10.3173 8.1879 11.9833 10.1617L11.99 10.155C11.99 10.155 12.7393 11.0181 13.5623 11.9481C13.5623 11.9481 14.499 13.0521 15.4893 14.0223C15.8773 14.397 17.7575 15.9091 19.564 15.9626C22.8759 16.0563 23.7926 13.5807 23.8394 13.3934C23.2306 16.0362 20.9222 18.0033 18.179 18.0167C15.9509 18.0167 13.6961 15.8288 12.0234 13.855C12.0234 13.8617 12.0167 13.8617 12.0167 13.8684C12.0167 13.8684 11.2674 13.0053 10.4444 12.0753C10.4511 12.0753 9.51437 10.9646 8.51743 9.99442Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4390_1065",
    x1: 15.04,
    y1: 6.9532,
    x2: 23.2885,
    y2: 15.2696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6841,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4390_1065",
    x1: 8.9621,
    y1: 17.0782,
    x2: 0.713598,
    y2: 8.76177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8929,
    stopColor: "#ACACAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcp);
export default __webpack_public_path__ + "static/media/icp.fc2c9a9cd21cc329c23b6e4a6d9b0427.svg";
export { ForwardRef as ReactComponent };